/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareLineOfBusinessItem
 */
export interface MatrixCareLineOfBusinessItem {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    label: string;
    /**
     * MatrixCare LOB category, e.g. "Home Health" or "Hospice". Hospice LOBs require a `startingCertPeriod` on create.
     */
    line_of_business_type: string;
}

/**
 * Check if a given object implements the MatrixCareLineOfBusinessItem interface.
 */
export function instanceOfMatrixCareLineOfBusinessItem(value: object): value is MatrixCareLineOfBusinessItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('line_of_business_type' in value) || value['line_of_business_type'] === undefined) return false;
    return true;
}

export function MatrixCareLineOfBusinessItemFromJSON(json: any): MatrixCareLineOfBusinessItem {
    return MatrixCareLineOfBusinessItemFromJSONTyped(json, false);
}

export function MatrixCareLineOfBusinessItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareLineOfBusinessItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'line_of_business_type': json['line_of_business_type'],
    };
}

export function MatrixCareLineOfBusinessItemToJSON(json: any): MatrixCareLineOfBusinessItem {
    return MatrixCareLineOfBusinessItemToJSONTyped(json, false);
}

export function MatrixCareLineOfBusinessItemToJSONTyped(value?: MatrixCareLineOfBusinessItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'line_of_business_type': value['line_of_business_type'],
    };
}

